/**
 * Fallback model list. The live list is fetched from the Anthropic API via
 * GET /models (cached ~24h) and used by the Settings dropdowns; this static
 * list is the offline fallback and is kept roughly current.
 */
export const AVAILABLE_MODELS = [
    { id: 'claude-fable-5-1', name: 'Claude Fable 5.1 (most capable)' },
    { id: 'claude-fable-5', name: 'Claude Fable 5' },
    { id: 'claude-opus-5', name: 'Claude Opus 5' },
    { id: 'claude-sonnet-5', name: 'Claude Sonnet 5' },
    { id: 'claude-opus-4-8', name: 'Claude Opus 4.8' },
    { id: 'claude-opus-4-7', name: 'Claude Opus 4.7' },
    { id: 'claude-opus-4-6', name: 'Claude Opus 4.6' },
    { id: 'claude-opus-4-5-20251101', name: 'Claude Opus 4.5' },
    { id: 'claude-sonnet-4-6', name: 'Claude Sonnet 4.6' },
    { id: 'claude-sonnet-4-5-20250929', name: 'Claude Sonnet 4.5' },
    { id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5 (fastest, cheapest)' },
];
// Pricing per million tokens (USD) — approximate; unknown models fall back to Sonnet rates
export const MODEL_PRICING = {
    'claude-fable-5-1': { input: 10.00, output: 50.00 },
    'claude-fable-5': { input: 10.00, output: 50.00 },
    'claude-opus-5': { input: 5.00, output: 25.00 },
    'claude-sonnet-5': { input: 3.00, output: 15.00 },
    'claude-opus-4-8': { input: 5.00, output: 25.00 },
    'claude-opus-4-7': { input: 5.00, output: 25.00 },
    'claude-opus-4-6': { input: 5.00, output: 25.00 },
    'claude-opus-4-5-20251101': { input: 15.00, output: 75.00 },
    'claude-sonnet-4-6': { input: 3.00, output: 15.00 },
    'claude-sonnet-4-5-20250929': { input: 3.00, output: 15.00 },
    'claude-haiku-4-5-20251001': { input: 0.80, output: 4.00 },
};
export function calculateCost(model, inputTokens, outputTokens) {
    const pricing = MODEL_PRICING[model] ?? { input: 3.00, output: 15.00 };
    return (inputTokens * pricing.input / 1_000_000) + (outputTokens * pricing.output / 1_000_000);
}
export const DEFAULT_AGENT_SETTINGS = {
    hermes: {
        model: 'claude-sonnet-4-6',
        maxTokens: 8192,
        runnerMode: 'api',
    },
    daedalus: {
        model: 'claude-sonnet-4-6',
        loopModel: 'claude-sonnet-4-6',
        maxTokens: 8192,
        maxTurns: 15,
        runnerMode: 'fargate',
    },
    prometheus: {
        model: 'claude-haiku-4-5-20251001',
        maxTokens: 4096,
        runnerMode: 'local',
    },
    athena: {
        model: 'claude-sonnet-4-6',
        maxTokens: 8192,
    },
    argus: {
        model: 'claude-sonnet-4-6',
        maxTokens: 8192,
        maxIterations: 5,
    },
};
//# sourceMappingURL=settings.js.map